import {
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  Inject,
  Injector,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewRef
} from '@angular/core';
import {Context} from './core/context';
import {FormBuilder} from '@angular/forms';
import {WidgetFactory} from './core/widget.factory';
import {WidgetRegistry} from './core';
import {SchemaParser} from './core/schema.parser';
import {SchemaValidator} from './core/schema.validator';
import {FormState} from './core/form.state';
import {WIDGET_REGISTRY} from './ng-json-editor-config';

@Component({
  selector: 'ng-json-editor',
  template: `
    <form *ngIf="context?.formGroup" [formGroup]="context?.formGroup">
      <ng-json-editor-form-element-chooser [context]="context" first="true">

      </ng-json-editor-form-element-chooser>
    </form>
  `,
  styleUrls: ['./ng-json-editor.component.scss']
})
export class NgJsonEditorComponent implements OnChanges {

  constructor(private fb: FormBuilder,
              private wf: WidgetFactory,
              @Inject(forwardRef(() => WIDGET_REGISTRY)) private wr: WidgetRegistry,
              private injector: Injector,
              public ref: ElementRef) {
    this.validator = new SchemaValidator(wr);
    this.state = new FormState(fb, wf, wr, this.validator, injector);
    this.parser = new SchemaParser(this.state);
  }

  @Input()
  public schema: any;

  @Input()
  public model: any = {};

  @Output()
  public onChange = new EventEmitter<{ value: any, errors: any[], valid: boolean, formValid: boolean, schemaValid: boolean }>();

  public context: Context<any>;

  private readonly parser: SchemaParser;
  private readonly validator: SchemaValidator;
  private readonly state: FormState;


  static isEmpty(data) {
    if (typeof (data) === 'object') {
      if (JSON.stringify(data) === '{}' || JSON.stringify(data) === '[]') {
        return true;
      } else if (!data) {
        return true;
      }
      return false;
    } else if (typeof (data) === 'string') {
      return !data.trim();
    } else {
      return typeof (data) === 'undefined';
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['schema']) {
      // console.log('schema changed');
      this.state.reset();
      this.parser.parse(this.schema, this.model || {}, true)
        .then(ctx => {
          this.context = ctx;

          if (!ctx) {
            this.state.reset();
            return;
          }

          ctx.formGroup.valueChanges.subscribe(v => {
            this.state.currentModel = v;
            Object.assign(this.model || {}, v);
            if (this.state.emitChangeEvent) {
              // console.log(JSON.stringify(this.state.currentModel), JSON.stringify(this.model))
              // if (JSON.stringify(this.state.currentModel) !== JSON.stringify(this.model)) {
              const schemaValid = this.validator.validate(this.schema, this.state.currentModel);
              const formValid = this.state.rootContext.formGroup.valid;
              const valid = schemaValid && formValid;
              const errors = this.validator.validationErrors(this.schema, this.state.currentModel);
              delete this.state.currentModel['$'];
              this.onChange.emit({
                value: this.removeEmptyStringsInBody(this.state.currentModel),
                errors: errors,
                valid: valid,
                formValid: formValid,
                schemaValid: schemaValid
              });
            }
            // }
          });
        })
        .catch((err) => {
          console.error(err);
        });
    }

    if (changes['model'] && changes['model'].previousValue) {
      if (JSON.stringify(changes['model'].previousValue || {}) !== JSON.stringify(this.state.currentModel || {})) {
        // noinspection JSIgnoredPromiseFromCall
        this.applyModelChanges();
      }
    }
  }

  private removeEmptyStringsInBody(body: any) {
    const bodyTemp = JSON.stringify(body, function (key, value) {
      return NgJsonEditorComponent.isEmpty(value) ? null : value;
    });
    return JSON.parse(bodyTemp);
  }

  private async applyModelChanges() {
    if (this.model && this.context) {
      // console.log('model changed');
      const model = this.model || {};
      await this.parser.parse(this.schema, model, false, null, null, '$', true);
    }
  }
}
